// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3qVWy","colMin":"styles_colMin__1UPjj","colCheckbox":"styles_colCheckbox__1YZj-"};